import { type FC, memo } from 'react';
// import { toast } from 'react-toastify';
import WalletConnected from './wallet-connected';
import WalletUnconnect from './wallet-unconnect';
import { useCurrentWallet } from '@mysten/dapp-kit';
import WalletDialog from './wallet-dialog';
import { useParrotInitBalances } from '@hooks/use-parrot-balance';
// import { formatAddress } from '@mysten/sui/utils';
// import { useAddress } from '@hooks/use-address';
// import styles from './index.module.scss';

const ConnectWallet: FC = () => {
  const wallet = useCurrentWallet();
  // const address = useAddress();
  useParrotInitBalances();

  // useEffect(() => {
  //   if (wallet.isConnected && wallet.currentWallet && address) {
  //     toast(
  //       <>
  //         <div className={styles.name}>{wallet.currentWallet.name} connected</div>
  //         <div className={styles.address}>{formatAddress(address)}</div>
  //       </>,
  //     );
  //   }
  // }, [wallet.isConnected, address]);

  return (
    <>
      {wallet.isConnected ? <WalletConnected /> : <WalletUnconnect />}
      <WalletDialog />
    </>
  );
};

export default memo(ConnectWallet);
